import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { id: "app" }, null, -1)

import { onBeforeUnmount, onMounted, onUpdated, computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const store = useStore();

router.afterEach((to, from) => {
  store.dispatch('moduleMenu/setMenus', to.name, { root: true });
});
router.beforeEach((to, from, next) => {
  if (to.name === 'Login') {
    next();
  } else {
    if (localStorage.getItem('isValidToken')) {
      if (to.name === 'Home') {
        return next({ name: 'DashBoard' });
      } else {
        next();
      }
    } else {
      return next({ name: 'Login' });
    }
  }
  if (to.name === 'Home') {
    next();
  }
  if (localStorage.getItem('isValidToken')) {
    next({
      name: 'DashBoard',
      replace: true,
    });
  } else {
    next({ name: 'Login' });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_router_view)
  ], 64))
}
}

})